// extracted by mini-css-extract-plugin
export default {"sliderItem":"banner_sliderItem__kHKHb","viewButton":"banner_viewButton__Gh5ht","bannerTitle":"banner_bannerTitle__AP2Lw","bannerWrapper":"banner_bannerWrapper__aTmkB"};